"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsBatchStatusRectangle = void 0;
var _react = _interopRequireDefault(require("react"));
var _BatchStatus = require("../../constants/BatchStatus");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
var _StatusProductionOrderBatchColors = require("../../constants/StatusProductionOrderBatchColors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsbatchStatusRectangle component
 * 
 * @param {object} status - Status of batch component
 */

const DmsBatchStatusRectangle = _ref => {
  let {
    status
  } = _ref;
  const statusColors = {
    [_BatchStatus.BatchStatus.CREATED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.CREATED,
    [_BatchStatus.BatchStatus.STARTED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.PRODUCTION_AND_STARTED,
    [_BatchStatus.BatchStatus.PAUSED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.PAUSED,
    [_BatchStatus.BatchStatus.FINISHED_OK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.FINISHED_OK,
    [_BatchStatus.BatchStatus.FINISHED_NOK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.FINISHED_NOK
  };
  const statusLabels = {
    [_BatchStatus.BatchStatus.CREATED]: _reactIntlUniversal.default.get("Created").d("Created"),
    [_BatchStatus.BatchStatus.STARTED]: _reactIntlUniversal.default.get("Started").d("Started"),
    [_BatchStatus.BatchStatus.PAUSED]: _reactIntlUniversal.default.get("Paused").d("Paused"),
    [_BatchStatus.BatchStatus.FINISHED_OK]: _reactIntlUniversal.default.get("FinishedOK").d("Finished OK"),
    [_BatchStatus.BatchStatus.FINISHED_NOK]: _reactIntlUniversal.default.get("FinishedNOK").d("Finished NOK")
  };
  const letterColors = {
    [_BatchStatus.BatchStatus.CREATED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_BatchStatus.BatchStatus.STARTED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_BatchStatus.BatchStatus.PAUSED]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.PAUSED_LETTER_COLOR,
    [_BatchStatus.BatchStatus.FINISHED_OK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR,
    [_BatchStatus.BatchStatus.FINISHED_NOK]: _StatusProductionOrderBatchColors.StatusProductionOrderBatchColors.WHITE_COLOR
  };
  const backgroundColor = statusColors[status];
  const label = statusLabels[status];
  const letterColor = letterColors[status];
  return /*#__PURE__*/_react.default.createElement(_material.Chip, {
    label: label,
    sx: {
      backgroundColor,
      color: letterColor,
      fontWeight: 'bold',
      minWidth: '5vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  });
};
exports.DmsBatchStatusRectangle = DmsBatchStatusRectangle;